import React from 'react';
import structure from './structure';
import { LOCAL_STATUS_CODE } from 'resources/constants/status';
import CustomTable from '../../components/Table';

const Create = () => {
  return <CustomTable statusCode={LOCAL_STATUS_CODE.CREATE} structure={structure} title={'create_link_table_title'} htmlId={'create-table-container'} />;
};

export default Create;
